import { computed, type ComputedRef } from 'vue'
import { useCore } from '@/composables/core'
import { getExternalId } from '@/lib/analytics/helpers'

type AnalyticsCommonParamsRootState = {
  routingConfig: { config: unknown }
  app: { country: string }
  identity?: { user?: { id?: string | number } }
  business?: { business?: { id?: string | number } }
}

export type UseAnalyticsCommonParamsReturn = {
  businessId: ComputedRef<string | null>
  country: ComputedRef<string>
  userId: ComputedRef<string | null>
}

export function useAnalyticsCommonParams (): UseAnalyticsCommonParamsReturn {
  const { store } = useCore()

  const routingConfig = computed(() => (store.state as AnalyticsCommonParamsRootState).routingConfig.config)
  const country = computed(() => (store.state as AnalyticsCommonParamsRootState).app.country)
  const user = computed(() => (store.state as AnalyticsCommonParamsRootState).identity?.user)
  const business = computed(() => (store.state as AnalyticsCommonParamsRootState).business?.business)

  const _getExternalId = (id: string | number | undefined): string | null => {
    return getExternalId({
      id,
      country: country.value,
      routingConfig: routingConfig.value,
    })
  }

  const userId = computed(() => _getExternalId(user.value?.id))
  const businessId = computed(() => _getExternalId(business.value?.id))

  return {
    businessId,
    country,
    userId,
  }
}
